import invariant from 'tiny-invariant';
import { supabase } from '@lib/supabase';

export async function postToApi<T>(
  path: string,
  description: string,
  method = 'POST',
  body?: object | undefined,
  noAuth = false
): Promise<T> {
  const session = await supabase.auth
    .getSession()
    .then(({ data }) => data.session);
  invariant(noAuth || session, `${description}: requires a signed in user`);

  // console.log(`posting: ${JSON.stringify(path)}`, { path, body });

  const response = await fetch(path, {
    method,
    headers: {
      Authorization: noAuth ? '' : `Bearer ${session?.access_token}`,
      'Content-Type': 'application/json',
    },
    body: body
      ? JSON.stringify({
          ...body,
        })
      : undefined,
  });

  // console.log(`PostToApi ${description} Response`, {
  //     responseStatus: response.status,
  //     responseOk: response.ok,
  //     responseStatusText: response.statusText,
  // });

  return handleResponse<T>(response);
}

async function handleResponse<T>(response: Response) {
  if (response?.status === 401) {
    console.log(response.status, response.url);
    const errorMessage = 'Invalid token - please log in again';
    throw new Error(errorMessage);
  }

  if (response?.status === 403) {
    console.log('API call forbidden', { response });
    const errorMessage = 'Unauthorized. User already exists.';
    throw new Error(errorMessage);
  }

  if (response?.status === 404) {
    console.log(response.status, response.url);
    console.log('endpoint not found!', { response });
    const errorMessage = 'Endpoint not found';
    throw new Error(errorMessage);
  }

  if (!response?.ok) {
    console.log('bad response!', { response });
    // TODO: maybe defaulting to text() is a bad idea? Depends on our API protocol for 500s I think...
    const errorText = (await response.text()) || 'Bad response from api';
    const errorMessage = `Server error (${response.status}): ${errorText}`;
    throw new Error(errorMessage);
  }

  return response.json() as T;
}
